import React, { useState } from 'react'
import { axiosCompanyFile, loadClientOptions, SpinnerButton } from '../../helpers/Common'
import { AsyncSelectInput } from '../../helpers/Input'
import { Close, LangFormatImportUpdateClientHelp, LangProcess, LangSpesificClient } from '../../constant/languange'

function ClientImportUpdateFormatComponent({ redux, handleClose, onAfterAdd }) {
  const [control, setControl] = useState({ onSubmit: false })
  const [clients, setClients] = useState([])
  const [responseData, setResponseData] = useState({})

  const handleDownloadFormat = (e) => {
    e.preventDefault()
    setControl(curr => ({ ...curr, onSubmit: true }))
    const submitForm = {
      client_id: clients?.map(item => item.value)
    }
    axiosCompanyFile().post('client-visit-clients/format-import-excel-update', submitForm)
      .then((res) => {
        const url = window.URL.createObjectURL(new window.Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'KERJOO-Format-Impor-Perbarui-Klien.xlsx')
        document.body.appendChild(link)
        link.click()
        onAfterAdd()
      })
      .catch(async (err) => {
        let errorMsg = err.response?.data
        if (
          err.request?.responseType === 'blob' &&
          err.response?.data instanceof Blob &&
          err.response?.data.type &&
          err.response?.data.type.toLowerCase().indexOf('json') !== -1
        ) {
          errorMsg = JSON.parse(await err.response.data.text())
        }
        setResponseData(typeof errorMsg === 'object' ? errorMsg : { message: 'Download gagal' })
      })
      .finally(() => {
        setControl(curr => ({ ...curr, onSubmit: false }))
      })
  }

  return (
    <div>
      <div className={`alert ${redux.darkModeOn ? 'alert-dark' : 'alert-light'}`}>
        {LangFormatImportUpdateClientHelp}
      </div>
      <form onSubmit={handleDownloadFormat}>
        <div className='d-flex flex-column justify-content-center' style={{ minHeight: 100 }}>
          <div className='form-group row'>
            <label className='col-sm-4 col-form-label text-lg-right'>{LangSpesificClient}</label>
            <div className='col-sm-7'>
              <AsyncSelectInput
                isLoading={false}
                isClearable
                isMulti
                loadOptions={loadClientOptions}
                value={clients}
                onChange={(value) => setClients(value || [])}
              />
            </div>
          </div>
        </div>
        <hr />
        <div className='form-group row'>
          <div className='offset-md-4 col-sm-7'>
            {responseData.message && <div className='alert alert-danger my-2 w-100'>{responseData.message}</div>}
          </div>
        </div>
        <div className='form-group row'>
          <div className='col-sm-7 offset-md-4'>
            <button disabled={control.onSubmit} type='submit' className='btn btn-primary'>{control.onSubmit ? SpinnerButton : null} {LangProcess}</button>
            &nbsp;
            <button onClick={handleClose} disabled={control.onSubmit} type='button' className='btn btn-light'>{Close}</button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default ClientImportUpdateFormatComponent
